import axios from "../utils/axios";

export const getAreaGroupListPlanned = (data) => {
    return axios.post(`/PlannedMaintenance/GetAreaGroupsStatistics?PageSize=${data.pageSize}&PageNumber=${data.currentPage}`, data);
};

export const getMainEquipmentListPlanned = (data) => {
    return axios.post(`/PlannedMaintenance/GetMainEquipmentsStatistics?PageSize=${data.pageSize}&PageNumber=${data.currentPage}`, data);
};

export const getSubEquipmentListPlanned = (data) => {
    return axios.post(`/PlannedMaintenance/GetSubEquipmentStatistics?PageSize=${data.pageSize}&PageNumber=${data.currentPage}`, data);
};

export const getSubEquipmentsTaskListPlanned = (data) => {
    return axios.post(`/PlannedMaintenance/GetTasksByStatisticsFilter?PageSize=${data.pageSize}&PageNumber=${data.currentPage}`, data);
};

export const getBreakdownReasonGroupData = () => {
    return axios.get(`/BreakdownReasonGroup/GetList`);
};

export const getBreakdownReasonPlaceData = () => {
    return axios.get(`/BreakdownReasonPlace/GetListWithGroup`);
};

export const getBreakdownEffectData = () => {
    return axios.get(`/BreakdownEffect/GetList`);
};

export const getBreakdownRootCauseData = () => {
    return axios.get(`/BreakdownRootCause/GetList`);
};

export const getMaintenanceTypeData  = () => {
    return axios.get(`/MaintenanceType/GetList`);
};

export const getPoolData = () => {
    return axios.get(`/Pool/GetList`);
};